<div class="p-[36px] bg-neutral">
  <div class="font-termina text-[32px]">Create Invite Link</div>

  <div class="bg-base-100 h-[4px] w-full rounded-[4px] my-[25px]"></div>

  <div class="flex items-center px-[22px] mb-[28px]">
    <div class="font-montserrat mr-[20px] text-inverted-neutral">Sending via</div>
    <select (change)="onDispatchTypeChanged()" class="input w-[180px] font-montserrat font-[18px]" [(ngModel)]="selectedInviteLinkDispatchType">
      @for (inviteLinkType of InviteLinkDispatchType | keyvalue; track inviteLinkType) {
        <option [value]="inviteLinkType.value">{{ inviteLinkType.key | camelCaseSplit }}</option>
      }
    </select>
  </div>

  <!-- Web Link -->
  @if (selectedInviteLinkDispatchType === InviteLinkDispatchType.WebLink) {
    <div>
      <div class="mb-[30px]">
        <div class="px-[22px] font-montserrat font-semibold">Invite Link Type</div>
        <select class="mt-[14px] border-[4px] border-accent rounded-[5px] py-2 px-4 flex w-[180px] font-montserrat font-[18px]" [(ngModel)]="selectedInviteLinkType">
          @for (inviteLinkType of InviteLinkType | keyvalue; track inviteLinkType) {
            <option [value]="inviteLinkType.value">{{ inviteLinkType.key | camelCaseSplit }}</option>
          }
        </select>
      </div>
      <div class="mb-[30px]">
        <div class="px-[22px] font-montserrat font-semibold">Expiry Date</div>
        <div class="mt-[14px] border-[4px] border-accent rounded-[5px] font-montserrat w-[180px]">
          <input class="p-2 pl-4 w-full" type="date" [(ngModel)]="linkExpiryDate" placeholder="Subject" />
        </div>
      </div>
      <div (click)="generateBespokeLink()" matRipple class="flex group items-center justify-center cursor-pointer rounded-[10px] bg-green-primary hover:bg-green-secondary text-green-secondary hover:text-green-primary w-[210px] h-[51px] m-auto">
        @if (!loading) {
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="Vector" d="M8.32087 12L19.3209 1M8.32087 12L11.8209 19C11.8647 19.0957 11.9352 19.1769 12.0238 19.2338C12.1125 19.2906 12.2156 19.3209 12.3209 19.3209C12.4262 19.3209 12.5293 19.2906 12.6179 19.2338C12.7066 19.1769 12.777 19.0957 12.8209 19L19.3209 1M8.32087 12L1.32087 8.5C1.22513 8.45613 1.144 8.38569 1.08712 8.29705C1.03024 8.20842 1 8.10532 1 8C1 7.89468 1.03024 7.79158 1.08712 7.70295C1.144 7.61431 1.22513 7.54387 1.32087 7.5L19.3209 1" class="stroke-green-secondary group-hover:stroke-green-primary" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        }
        @if (loading) {
          <svg class="animate-spin" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="COCO/Line/Rotate - Right"><path id="Vector" d="M21.5059 12.7058C21.5059 17.5921 17.4764 21.5532 12.5059 21.5532C7.5353 21.5532 3.50586 17.5921 3.50586 12.7058C3.50586 7.81945 7.50586 3.8583 12.5059 3.8583C18.5059 3.8583 21.5059 8.77356 21.5059 8.77356M21.5059 8.77356L21.5059 3.55322M21.5059 8.77356H16.8508" class="stroke-green-secondary group-hover:stroke-green-primary" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g>
          </svg>
        }
        <div class="text-[16px] font-montserrat py-2 px-4">{{ loading ? 'Generating' : 'Generate Link' }}</div>
      </div>
    </div>
  }

  <!-- Email -->
  @if (selectedInviteLinkDispatchType === InviteLinkDispatchType.Email) {
    <div>
      <div class="px-[22px] font-montserrat font-semibold">Send to ({{ remoteInviteRecipients.length }} recipients)</div>
      <div class="flex flex-wrap gap-4 mt-[14px] mb-[30px]">
        <div class="border-[4px] border-accent rounded-[5px] pr-4 font-montserrat flex items-center">
          <input [(ngModel)]="currentRecipientInput" class="py-2 px-4" placeholder="Add email address" />
          <span (click)="addRecipient()" class="ml-4 h-[21px] w-[21px] cursor-pointer material-symbols-outlined text-inverted-neutral text-[21px]" aria-label="Add Recipient">add</span>
        </div>
        @for (recipient of remoteInviteRecipients; track recipient) {
          <div class="border-[4px] border-accent rounded-[5px] py-2 px-4 font-montserrat">
            {{ recipient }}
          </div>
        }
      </div>
      <div class="mb-[30px]">
        <div class="px-[22px] font-montserrat font-semibold">Subject</div>
        <div class="mt-[14px] border-[4px] border-accent rounded-[5px] font-montserrat flex">
          <input [(ngModel)]="messageInfo.subject" class="w-full p-2 pl-4" placeholder=Subject />
        </div>
      </div>
      <div class="mb-[30px]">
        <div class="px-[22px] font-montserrat font-semibold">Message</div>
        <div class="mt-[14px] border-[4px] border-accent rounded-[5px] font-montserrat flex">
          <input [(ngModel)]="messageInfo.message" class="w-full p-2 pl-4" placeholder="Message" />
        </div>
      </div>
      <div class="mb-[30px]">
        <div class="px-[22px] font-montserrat font-semibold">Invite Link Type</div>
        <select class="p-2 pl-4 mt-[14px] border-[4px] border-accent rounded-[5px] flex w-[180px] font-montserrat font-[18px]" [(ngModel)]="selectedInviteLinkType">
          @for (inviteLinkType of InviteLinkType | keyvalue; track inviteLinkType) {
            <option [value]="inviteLinkType.value">{{ inviteLinkType.key | camelCaseSplit }}</option>
          }
        </select>
      </div>
      <div class="mb-[30px]">
        <div class="px-[22px] font-montserrat font-semibold">Expiry Date</div>
        <div class="mt-[14px] border-[4px] border-accent rounded-[5px] font-montserrat w-[180px]">
          <input class="p-2 pl-4" type="date" [(ngModel)]="linkExpiryDate" placeholder=Subject />
        </div>
      </div>
      <button [disabled]="remoteInviteRecipients.length === 0 || loading" (click)="sendRemoteInviteLinks()" matRipple class="flex disabled:opacity-30 group items-center justify-center rounded-[10px] bg-green-primary enabled:hover:bg-green-secondary text-green-secondary enabled:hover:text-green-primary w-[210px] h-[51px] m-auto">
        @if (!loading) {
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="Vector" d="M8.32087 12L19.3209 1M8.32087 12L11.8209 19C11.8647 19.0957 11.9352 19.1769 12.0238 19.2338C12.1125 19.2906 12.2156 19.3209 12.3209 19.3209C12.4262 19.3209 12.5293 19.2906 12.6179 19.2338C12.7066 19.1769 12.777 19.0957 12.8209 19L19.3209 1M8.32087 12L1.32087 8.5C1.22513 8.45613 1.144 8.38569 1.08712 8.29705C1.03024 8.20842 1 8.10532 1 8C1 7.89468 1.03024 7.79158 1.08712 7.70295C1.144 7.61431 1.22513 7.54387 1.32087 7.5L19.3209 1" class="stroke-green-secondary group-enabled:group-hover:stroke-green-primary" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        }
        @if (loading) {
          <svg class="animate-spin" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="COCO/Line/Rotate - Right"><path id="Vector" d="M21.5059 12.7058C21.5059 17.5921 17.4764 21.5532 12.5059 21.5532C7.5353 21.5532 3.50586 17.5921 3.50586 12.7058C3.50586 7.81945 7.50586 3.8583 12.5059 3.8583C18.5059 3.8583 21.5059 8.77356 21.5059 8.77356M21.5059 8.77356L21.5059 3.55322M21.5059 8.77356H16.8508" class="stroke-green-secondary group-enabled:group-hover:stroke-green-primary" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g>
          </svg>
        }
        <div class="text-inverted-neutral text-[16px] font-montserrat py-2 px-4">{{ loading ? 'Sending' : 'Send Message/s' }}</div>
      </button>
    </div>
  }

  <!-- Text Message -->
  @if (selectedInviteLinkDispatchType === InviteLinkDispatchType.TextMessage) {
    <div>
      <div class="px-[22px] font-montserrat font-semibold">Send to ({{ remoteInviteRecipients.length }} recipients)</div>
      <div class="flex flex-wrap gap-4 mt-[14px] mb-[30px]">
        <div class="border-[4px] border-accent rounded-[5px] pr-4 font-montserrat flex items-center">
          <div class="flex h-full items-center justify-center pl-2 pr-3 border-accent"><span>+64</span></div>
          <input class="p-2 pl-4" [(ngModel)]="currentRecipientInput" placeholder="Add phone #" />
          <span (click)="addRecipient()" class="ml-4 h-[21px] w-[21px] cursor-pointer material-symbols-outlined text-inverted-neutral text-[21px]" aria-label="Add Recipient">add</span>
        </div>
        @for (recipient of remoteInviteRecipients; track recipient) {
          <div class="border-[4px] border-accent rounded-[5px] pr-4 font-montserrat flex items-center">
            <div class="flex h-full items-center justify-center pl-2 pr-3 border-accent"><span>+64</span></div>
            <div class="p-2 pl-4">{{ recipient }}</div>
          </div>
        }
      </div>
      <div class="mb-[30px]">
        <div class="px-[22px] font-montserrat font-semibold">Message</div>
        <div class="mt-[14px] border-[4px] border-accent rounded-[5px] font-montserrat flex">
          <input [(ngModel)]="messageInfo.message" class="p-2 pl-4 w-full" placeholder="Message" />
        </div>
      </div>
      <div class="mb-[30px]">
        <div class="px-[22px] font-montserrat font-semibold">Invite Link Type</div>
        <select class="mt-[14px] border-[4px] border-accent rounded-[5px] py-2 px-4 flex w-[180px] font-montserrat font-[18px]" [(ngModel)]="selectedInviteLinkType">
          @for (inviteLinkType of InviteLinkType | keyvalue; track inviteLinkType) {
            <option [value]="inviteLinkType.value">{{ inviteLinkType.key | camelCaseSplit }}</option>
          }
        </select>
      </div>
      <div class="mb-[30px]">
        <div class="px-[22px] font-montserrat font-semibold">Expiry Date</div>
        <div class="mt-[14px] border-[4px] border-accent rounded-[5px] font-montserrat w-[180px]">
          <input class="p-2 pl-4" type="date" [(ngModel)]="linkExpiryDate" placeholder=Subject />
        </div>
      </div>
      <button [disabled]="remoteInviteRecipients.length === 0 || loading" (click)="sendRemoteInviteLinks()" matRipple class="flex disabled:opacity-30 group items-center justify-center rounded-[10px] bg-green-primary enabled:hover:bg-green-secondary text-green-secondary enabled:hover:text-green-primary w-[210px] h-[51px] m-auto">
        @if (!loading) {
          <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path id="Vector" d="M8.32087 12L19.3209 1M8.32087 12L11.8209 19C11.8647 19.0957 11.9352 19.1769 12.0238 19.2338C12.1125 19.2906 12.2156 19.3209 12.3209 19.3209C12.4262 19.3209 12.5293 19.2906 12.6179 19.2338C12.7066 19.1769 12.777 19.0957 12.8209 19L19.3209 1M8.32087 12L1.32087 8.5C1.22513 8.45613 1.144 8.38569 1.08712 8.29705C1.03024 8.20842 1 8.10532 1 8C1 7.89468 1.03024 7.79158 1.08712 7.70295C1.144 7.61431 1.22513 7.54387 1.32087 7.5L19.3209 1" class="stroke-green-secondary group-enabled:group-hover:stroke-green-primary" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        }
        @if (loading) {
          <svg class="animate-spin" width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="COCO/Line/Rotate - Right"><path id="Vector" d="M21.5059 12.7058C21.5059 17.5921 17.4764 21.5532 12.5059 21.5532C7.5353 21.5532 3.50586 17.5921 3.50586 12.7058C3.50586 7.81945 7.50586 3.8583 12.5059 3.8583C18.5059 3.8583 21.5059 8.77356 21.5059 8.77356M21.5059 8.77356L21.5059 3.55322M21.5059 8.77356H16.8508" class="stroke-green-secondary group-enabled:group-hover:stroke-green-primary" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g>
          </svg>
        }
        <div class="text-[16px] font-montserrat py-2 px-4">{{ loading ? 'Sending' : 'Send Message/s' }}</div>
      </button>
    </div>
  }

  <!-- Social Media -->

  <!-- Website -->

  @if (selectedInviteLinkDispatchType === InviteLinkDispatchType.Website || selectedInviteLinkDispatchType === InviteLinkDispatchType.SocialMedia) {
    <div>
      <div class="font-montserrat">Coming soon!</div>
    </div>
  }

  @if (selectedInviteLinkDispatchType === InviteLinkDispatchType.WebLink && inviteLink) {
    <div>
      <div class="bg-base-100 h-[4px] w-full rounded-[4px] my-[25px]"></div>
      <div [ngClass]="copiedToClipboard ? 'bg-green-primary' : 'bg-base-200'" class=" bg-opacity-50 h-[36px] rounded-[5px] flex items-center py-[4px] px-[4px]">
        <input class="h-full font-montserrat text-[16px] rounded-[2px] pl-4 flex-grow" [(ngModel)]="inviteLink.url" readonly />
        <div [cdkCopyToClipboard]="inviteLink.url" (click)="onClickCopyToClipboard()" class="px-[18px] flex items-center cursor-pointer">
          @if (!copiedToClipboard) {
            <span class="mr-[13px] h-[21px] w-[21px] cursor-pointer material-symbols-outlined text-inverted-neutral text-[21px]" aria-label="Copy Link">content_copy</span>
          }
          <div class="whitespace-nowrap font-montserrat">{{ copiedToClipboard ? 'Copied!' : 'Copy Url' }}</div>
        </div>
      </div>
    </div>
  }
</div>